import { Injectable } from '@angular/core';
import { Adapter } from '../types';
import {
  AppointmentDate,
  AppointmentSlot,
  AppointmentAdapterType
} from '../../modules/appointment/appointment.types';
import { LoadingInfo } from '../types';

@Injectable({
  providedIn: 'root',
})
export class AppointmentAdapter implements Adapter<AppointmentDate> {

  adapt(data: AppointmentAdapterType): AppointmentDate {
    const slots: AppointmentSlot[] = data.appointmentTimes?.map(slot => ({
      startTime: new Date(slot.appointmentStartTime),
      endTime: new Date(slot.appointmentEndTime)
    })) ?? [];

    const appointmentDate = data.appointmentTimes?.length > 0
      ? new Date(data.appointmentTimes[0].appointmentStartTime)
      : data.date;

    const loadingInfo: LoadingInfo = {
      loading: false,
      error: false,
      lastUpdate: new Date()
    };

    const result: AppointmentDate = {
      date: appointmentDate,
      slots,
      loadingInfo
    };

    return result
  }
}